 <template>
	<div class='content'>
		<van-nav-bar
		   title="订单列表"
		   left-text=""
		   right-text=""
		   left-arrow
		   @click-left="onClickLeft"
		  @click-right="onClickRight"
		/>
		<van-cell-group class='box_groupa' style="padding-bottom: 80px; background-color:#F4F5F7  ;" >
			<div v-for="(item,index) in list" :key="index">
				 <van-row  class="box_visita"  style="background-color: #FFFFFF; margin-top: 5px;margin-bottom: 5px;">
				  	<van-col span="24" style="width: 100%;margin-left: 0%;border-left: 0px;border-right: 0px;">

						<van-col class="list" span="24"  style="border-color: transparent; text-align: left;height:33xp;line-height: 33px;">
		  	  		  		<van-col span="10" style="padding-left:10px; color: #999999;" >
	  	  		  		 		订单号：
	  	  		  		 	</van-col>
	  	  		  		 	<van-col span="14" style="text-align: right;padding-right:10px;">
	  	  		  		 		{{item.order}}<span v-if="hide">{{item.id}}</span>
	  	  		  		 	</van-col>
		  	  		    </van-col>
		  	  		    <van-col class="list" span="24"  style="border-color: transparent; text-align: left;height:33xp;line-height: 33px;">
                  <van-col span="10"  style="padding-left:10px; color: #999999;" >
                    下单时间：
                  </van-col>
                  <van-col span="14" style="text-align: right;padding-right:10px;">
                    {{item.time}}
                </van-col>
					    </van-col>

					    <van-col class="list"  span="24"  style="border-color: transparent; text-align: left;height:33xp;line-height: 33px;">
					    	<van-col span="10"  style="padding-left:10px; color: #999999;" >
					    		数量：
					    	</van-col>
					    	<van-col span="14" style="text-align: right;padding-right:10px;">
					    	  {{item.num}}
					    	</van-col>
						</van-col>
						<van-col class="list" span="24"  style="border-color: transparent; text-align: left;height:33xp;line-height: 33px;">
							<van-col span="10"  style="padding-left:10px; color: #999999;" >
								金额：
							</van-col>
							<van-col span="14" style="text-align: right;padding-right:10px;">
							   {{item.total}}
							</van-col>
						</van-col>
						<van-col class="list" span="24"  style=" text-align: left;height:33xp;line-height: 33px; ">
							<van-col span="10"  style="padding-left:10px; color: #999999;" >
								次数/时间：
							</van-col>
							<van-col span="14" style="text-align: right;padding-right:10px;">
							  {{item.remainTimes}}
							</van-col>
						</van-col>
						<van-col class="list" span="24"  style="border:0px; ">
						 <span style="display: inline-block; width:100%; border-bottom: 1px solid #F4F4F4;"></span>
						</van-col>
					    <van-col class="list" @click="ticketlist(index)" span="24"  style="border-color: transparent; text-align: left;height:33xp;line-height: 33px;">
					   	  	<van-col span="18" style="color:#369AFF; padding-left:10px;">
							查看门票详情信息
							</van-col>
							<van-col span="6" style="padding-top:4px; text-align: right;padding-right:10px;" >
							  <van-icon name="arrow"  size="18" color="#999999"/>
							</van-col>
						</van-col>
			 		    <van-col  class="list" @click="ticketQR(index)"  span="24" style="border-color: transparent; text-align: left;height:33xp;line-height: 33px;">
					   	  	<van-col span="18" style="color: #FF4A53; padding-left:10px" >
							查看通行的二维码
							</van-col>
							<van-col span="6" style="padding-top:4px; text-align: right;padding-right:10px;">
							  <van-icon name="arrow"  size="18" color="#999999"/>
							</van-col>

						</van-col>
				    </van-col>
			    </van-row>

			</div>
		</van-cell-group>
	    <van-tabbar v-model="active" active-color="#FF4A53">
			    <van-tabbar-item icon="home-o" @click="home()">购票首页</van-tabbar-item>
				<van-tabbar-item icon="setting-o"  @click="user()">个人中心</van-tabbar-item>
		</van-tabbar>

	</div>
</template>

<script>
  export default {
  data () {
    return {
    	 active:1,
    	 order:'',
    	 total:"",
    	 numlist:'',
    	 timeDate:'',
    	 currentDate: new Date(),
    	 phone:'',
   	     text: '',
	     message:'',
	     isLoadingShow: true,
    	 hide:false,

	     finished: false,
         show: false,
         className: '',
         showCalendar: false,
         list:[]
	    }
    },
    mounted(){
    	//this.time();
    	this.orderlist();
    },
	methods: {
		orderlist(){
			  const loading = this.$loading({
		          lock: true,
		          text: 'Loading',
		          spinner: 'el-icon-loading',
		          background: 'rgba(0, 0, 0, 0.4)'
		        });
		   	let storage=window.sessionStorage;
    		let openid = storage.getItem("openid")
         let token = storage.getItem("token")
        if(openid == null || openid == "null" || openid == "undefined" || openid == undefined || openid== "" ){
             alert("openID获取失败，请退出公众号在重新进入");
               loading.close()//关闭 Loading 加载
              return
            }
			this.$axios({
					url: "/api/order/wxOrderList",
					method: "get",
					params: {
						openid: openid,
					},
          headers: {
            "authorization": token,
            "Content-Type": "application/json; charset=utf-8"
          }
				})
			.then(res => {
				 setTimeout(() => {
				     loading.close()//关闭 Loading 加载
				    }, 800)
				var data = res.data[0];
				 console.log(data)
			    for (const i in data) {
		           this.list.push({
			        	  order:data[i].orderID,
				          time:data[i].orderTime,
				          num:data[i].ticketNum,
				          total:data[i].orderAmount,
				    	    remainTimes:data[i].remainTimes,

			         });


		      }
			 })
				.catch(err => {
					  setTimeout(() => {
				     loading.close()//关闭 Loading 加载
				    }, 800)
				console.log(err);
			});

		},

		ticketlist(index){
			 let order = this.list[index].order;
			 let total = this.list[index].total;
			 this.$router.push({ path: "/wx_ticketOrderTicket",query: { order: order,total:total}});
		},
		ticketQR(index){
			 let order = this.list[index].order;
			 this.$router.push({ path: "/wx_ticketOrderQR",query: { order: order }});
		},
		 home(){
	    	 this.$router.push({ path: "/wx_ticketIndex" });
	    },
	    user(){
	    	 this.$router.push({ path: "/wx_ticketUser" });
	    },
		onLoad() {
	        this.loading = false;
		    	this.finished = true;

	    },
	    onClickLeft(){
	    	this.$router.go(-1);//返回上一层
			//this.$router.push({ path: "/wx_ticketUser",query: { total: total , numlist: numlist }  });
		},
		onClickRight(){

		},
			// 选项格式化函数
		onSubmit(){

		 },
        time(){
		      this.timeDate=this.dateFormat();
		      this.total = this.$route.query.total;
		      this.numlist= this.$route.query.numlist;

		    },
		onConfirm(date) {
		 	  this.timeDate = `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;
		      this.showCalendar = false;
		    },
		dateFormat() {//获取当前时间
		        var date=new Date();
		        var year=date.getFullYear();
		        var month= date.getMonth()+1<10 ? +(date.getMonth()+1) : date.getMonth()+1;
		        var day=date.getDate()<10 ? +date.getDate() : date.getDate();
		        //var hours=date.getHours()<10 ? "0"+date.getHours() : date.getHours();
		        //var minutes=date.getMinutes()<10 ? "0"+date.getMinutes() : date.getMinutes();
		        //var seconds=date.getSeconds()<10 ? "0"+date.getSeconds() : date.getSeconds();
		        return year+"-"+month+"-"+day
            },
      /*  showPopup () {
	        this.show = true
	        this.isLoadingShow = true
	        setTimeout(() => {
	           this.isLoadingShow = false
	        }, 500)
        },*/




	}
}
</script>

<style scoped>


	.box_visita .list i {
		color: #00B2AD;
		width: 20px;
		height: 20px;
		font-size: 15px;

		margin-left: 10px;
	}
	.content{
		width: 100%;
		height: 100%;
		font-family: "arial, helvetica, sans-serif" !important;
		background-color: rgb(244, 245, 247);
	}
	.box_visit .check{
		text-align: right !important;
	}
    .box_visit  .check i {
		margin-left: 0px !important;
		margin-right: 8px !important;
		margin-top:10px;
	}
	.check_code{
		display:inline-block;
		width: 80px;
		height: 33px;
		position: relative;
		top: -2.5px;
		}
	.icon_color1 i {
		color:#1989fa;
	}
	.icon_color2 i {
		color:#19c160;
	}
	.icon_color3 i {
		color:#07c160;
	}
	.icon_color4 i {
		color:#4fc08d;
	}
	.icon_color5 i {
		color:#2989fa;
	}

</style>



// WEBPACK FOOTER //
// src/system/index/wechatlist/wx_ticketOrderlist.vue